// Shared utility for mapping car type descriptions to Umbraco images
// Used by both Homepage SearchBlock and Search page filters

export interface TypeImage {
  carName: string
  imageNormal: string
  imageOn: string
}

// Mapping of Hebrew car type descriptions to English image names from Umbraco
export const carTypeDescriptionMapping: Record<string, string> = {
  "ג'יפ (פנאי שטח- גדול)": "Large SUV",
  "ג'יפונים (פנאי שטח- בינוני)": "Mid-size SUV",
  "ג'יפונים (פנאי שטח- קטן)": "Mid-size SUV",
  מנהלים: "Managers/Executive",
  משפחתיות: "Family",
  ספורט: "Sports",
  מסחרי: "Commercial",
  מיני: "mini",
  מינוואנים: "Minivan",
}

/**
 * Maps a car type description (Hebrew) to its corresponding Umbraco image data
 * @param description - The Hebrew description of the car type
 * @param typeImages - Array of type images from Umbraco
 * @returns The matching TypeImage object or undefined if not found
 */
export function mapCarTypeToImage(
  description: string,
  typeImages: TypeImage[],
): TypeImage | undefined {
  let mappedName = carTypeDescriptionMapping[description]

  if (!mappedName) {
    const matchingKey = Object.keys(carTypeDescriptionMapping).find((key) =>
      key.includes(description),
    )
    if (matchingKey) {
      mappedName = carTypeDescriptionMapping[matchingKey]
    }
  }

  if (!mappedName) return undefined

  return typeImages.find((img) => img.carName === mappedName)
}
